/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */
import React, { Fragment } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useTransition, animated } from '@react-spring/web';
import styles from './assets/styles.scss';
import Backdrop from '../Backdrop/Backdrop';
import IconClose from './assets/close.svg?inline';

const cx = classNames.bind(styles);

export default function Modal({
  isOpen,
  onClose,
  header,
  children,
  dark,
  fullMobileWidth,
  className,
  bodyRef,
  backgroundColor,
  modalClassName,
  footerContent,
  unmountOnClose,
}) {
  const transition = useTransition(isOpen, {
    from: { opacity: 0, scale: 0 },
    enter: { opacity: 1, scale: 1 },
    leave: { opacity: 0, scale: 0 },
    expires: unmountOnClose,
  });

  return createPortal(
    <Fragment>
      <Backdrop visible={isOpen} onClick={onClose} />
      {transition(
        (style, item) => item && (
          <animated.div
            style={style}
            className={cx('modal', { dark, 'full-mobile-width': fullMobileWidth })}
            onClick={onClose}
            role="dialog"
          >
            <div
              className={cx('modal-content', modalClassName)}
              onClick={e => e.stopPropagation()}
              role="dialog"
              style={{ backgroundColor }}
            >
              {typeof header === 'string' ? (
                <div className="header">
                  <h3 className={cx('text')}>{header}</h3>
                  <button type="button" aria-label="Close" className={cx('close-button')} onClick={onClose}>
                    <IconClose />
                  </button>
                </div>
              ) : (
                header
              )}
              <div className={`${cx('body')} ${className}`} ref={bodyRef}>
                {children}
              </div>
              {footerContent}
            </div>
          </animated.div>
        )
      )}
    </Fragment>,
    document.getElementsByTagName('body')[0]
  );
}
Modal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  dark: PropTypes.bool,
  bodyRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  backgroundColor: PropTypes.string,
  modalClassName: PropTypes.string,
  footerContent: PropTypes.element,
  unmountOnClose: PropTypes.bool,
};

Modal.defaultProps = {
  isOpen: false,
  onClose: () => {},
  header: null,
  children: null,
  dark: false,
  bodyRef: null,
  backgroundColor: null,
  modalClassName: null,
  footerContent: null,
  unmountOnClose: true,
};
